import { useState, useEffect } from "react";
import { getDocuments } from "../../../api/documentAPI";
import { DocumentData, DocumentType } from "../../../types/api/documents";
import { DocTagIdsMapper, TextMapper } from "../types/documentTypes";

export interface DataResult {
    order?: DocumentData[];
    acts?: DocumentData[];
    price?: DocumentData[];
    timetable?: DocumentData[];
}

const mapper: Record<number, keyof DataResult> = {
    0: TextMapper.ORDER,
    1: TextMapper.ACTS,
    2: TextMapper.PRICE,
    3: TextMapper.TIMETABLE,
};

export const useParallelRequests = (centerId: string) => {
    const [error, setError] = useState<unknown>();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<DataResult>({});
    const [isRefresh, setIsRefresh] = useState<boolean>(false);

    const refreshData = () => {
        setIsRefresh(prev => !prev);
    };

    const fetchData = async () => {
        try {
            const promises = [
                getDocuments(centerId, { format: DocumentType.DOCUMENT, tag_id: DocTagIdsMapper.ORDER }),
                getDocuments(centerId, { format: DocumentType.DOCUMENT, tag_id: DocTagIdsMapper.ACTS }),
                getDocuments(centerId, { format: DocumentType.DOCUMENT, tag_id: DocTagIdsMapper.PRICE }),
                getDocuments(centerId, { format: DocumentType.DOCUMENT, tag_id: DocTagIdsMapper.TIMETABLE }),
            ];

            Promise.race(promises)
                .catch(err => setError(err))
                .finally(() => {
                    setLoading(false);
                });

            const results = await Promise.allSettled(promises);

            const newData: DataResult = {};
            results.forEach((result, index) => {
                if (result.status === "fulfilled") {
                    newData[mapper[index]] = result.value.data;
                }
            });

            setData(newData);
        } catch (error) {
            setError(error);
        }
    };
    useEffect(() => {
        fetchData();
    }, [isRefresh]);

    return { loading, setLoading, data, error, refreshData };
};
